import React from 'react'

import { connect } from 'react-redux';

import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";

import * as actions from  '../../actions/inventarioFisico';

import _ from "lodash";

import {api} from '../../actions/_request';

import Menu from '../facturacion/menu.js';

import ModalInventario from './inventarioFisicoModal.js'
import ModalHistoricos from './inventarioFisicoHistoricos.js'

import IconEdit from 'react-icons/lib/md/edit';

import IconList from 'react-icons/lib/fa/list-alt'

import IconHistorico from 'react-icons/lib/fa/archive'

import swal from 'sweetalert2'

const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        // var label="";
        // var telefono="";
        // var usuario="";
        // var value="";

        /* Campos para filtrar */
        var codigo='';
        var label='';
        var linea='';
        var almacen_nombre = '';
        /*  */
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "label":
              label=filtered[i].value;
              break;
            case "linea":
              linea=filtered[i].value;
              break;            
            case "codigo":
              codigo=filtered[i].value;
              break;
            case "almacen_nombre":
              almacen_nombre=filtered[i].value;
            break;         
          }
        }
        api().get(`/inventarioFisico/conteo?codigo=${codigo}&label=${label}&almacen_nombre=${almacen_nombre}&linea=${linea}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/inventarioFisico/busqueda?codigo=${codigo}&label=${label}&almacen_nombre=${almacen_nombre}&linea=${linea}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};

class InventarioFisico extends React.Component{
	constructor(props) {
        super(props);
        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
            modalHistoricos : false,
	        data: [],
	        pages: null,
	        loading: true
        };
        this.toggle 			= this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.delete = this.delete.bind(this);
        this.toggleHistoricos = this.toggleHistoricos.bind(this);
        this.aplicarInventario = this.aplicarInventario.bind(this);
    }

    fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      this.props.get(res.rows);
    });
  }
  toggle(evt, prospectoid = null, title = "Agregar Inventario Fisico")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }
  toggleHistoricos(evt){
    let {modalHistoricos} = this.state;

    this.setState({
      modalHistoricos : !modalHistoricos
    })
  }

    delete(evt,invt_fis_id,row_index){
      let self = this;
      evt.preventDefault();
      swal({
        title: 'Estas seguro?',
        text: "Se eliminara  el producto del Inventario Fisico",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
         cancelButtonText: 'Cancelar!'
      }).then((result) => {
        if (result.value) {
             
             self.props.delete2(invt_fis_id,row_index);

        }
      });
      
    }

    aplicarInventario(evt){
      let self = this;
      evt.preventDefault();
      let referencia
      swal({
        title: 'Estas seguro?',
        text: "Aplicar Inventario Fisico",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
         cancelButtonText: 'Cancelar!'
      }).then((result) => {
        if (result.value) {
            swal({
              title: 'Por favor escribe la referencia',
              input: 'text',
              showCancelButton: true,
              confirmButtonText: 'Aplicar!',
              showLoaderOnConfirm: true,
              cancelButtonText: 'Cancelar!',
              preConfirm: (referencia_val) => {

                if(referencia_val == "") {
                  swal.showValidationError('Se requiere la referencia');
                }
                else {
                  referencia= referencia_val;

                  return api().post('/inventarioFisico/aplicarInventario/'+referencia)
                  .then(response => response)
                  .catch( error => {
                    swal.showValidationError(`Request failed ${error}`);
                  });
                }
              },
              allowOutsideClick: () => !swal.isLoading(),
            }).then((result) => {
              
              let bandera = true;
                if(result.dismiss == 'cancel' || result.dismiss == 'overlay')
                  bandera = false;
                
                if(bandera){
                  if (result.value.status === 200 && result.value.data.validacion) {
                    swal("Bien hecho!", "Se ha aplicado correctamente el inventario fisico "+result.value.data.referencia+" !", "success");
                    self.props.borrarData();
                  }else{
                      swal("Error!", "La referencia ingresada ya existe o no es valida", "error");
                  }
                }
            });
        }
      });
    }

    render(){
    	const { data, pages, loading } = this.state;
      // console.log(this.props.inventarioFisico.data)
    	return(

    		<div className="view">
            	<Menu props={this.props}/>
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase"> Inventario Fisico</h1>
                    </header>
                </div>
           		<div className="view-content view-components">
                    <Card>
                        <CardBlock>
                          <div className="text-right">
                            <Button color="success" className="mb-2" onClick={this.toggle}>
                                {<IconList/>}&nbsp;Agregar
                            </Button>
                            {' '}
                            <Button color="info" className="mb-2" onClick={this.toggleHistoricos}>
                              {<IconHistorico />}{' '}Historico
                            </Button>{' '}
                            <Button color="warning" className="mb-2" onClick={this.aplicarInventario}>
                              {<IconHistorico />}{' '}Aplicar Inventario
                            </Button>
                          </div>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.value, 'Editar Inventario Fisico')
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Codigo', accessor: 'item_codigo',maxWidth:150 },
                                {Header: 'Nombre', accessor: 'label'},
                                {Header: 'Almacen', accessor: 'almacen_nombre'},
                                {Header: 'Linea', accessor: 'linea' },
                                {Header: 'Fisico', accessor: 'fisico' , filterable: false},
                                {Header: 'Existencia', accessor: 'existencia',filterable: false},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:150,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.value, 'Editar Inventario Fisico')}>
                                                    <IconEdit />
                                                </Button>{' '}
                                                <Button
                                                  color="danger"
                                                  className="btn-sm"
                                                  onClick={(evt)=>this.delete(evt, row.original.value, row.index)}
                                                >{'X'}
                                                </Button>
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.inventarioFisico.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10} 
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <ModalInventario 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                 
                />
                }
                {
                  this.state.modalHistoricos&& 
                   <ModalHistoricos
                    open={this.state.modalHistoricos} 
                    toggle={this.toggleHistoricos} 
                    title={this.state.title} 
                    prospectoid={this.state.prospectoid}
                  />
                }
            </div>

    	)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        inventarioFisico : state.inventarioFisico,
    }
};

export default connect(mapStateToProps, actions)(InventarioFisico)


// WEBPACK FOOTER //
// ./src/views/inventarioFisico/index.js